/* @flow */
import Chat from 'entities/Chat';
import ChatActions from 'chat/actions/ChatActions';
import ChatForm from './ChatForm.jsx';
import ConversationSidebarParticipants from './ConversationSidebarParticipants.jsx';
import EmailChatHistoryButton from './EmailChatHistoryButton.jsx';
import LeaveChatButton from './LeaveChatButton.jsx';
import ManageChatButton from './ManageChatButton.jsx';
import React from 'react';

import cx from 'classnames';

import './styles/ConversationSidebar.scss';

class ConversationSidebar extends React.Component {
  static propTypes = {
    chat: React.PropTypes.instanceOf(Chat).isRequired,
    style: React.PropTypes.object,
  };

  renderParticipantsHeader() {
    const { chat } = this.props;
    let text = null;

    if (chat.isGroupType()) {
      const number = chat.getOtherChatMembershipsWithState('present').length + 1;
      text = number === 1 ? '1 person' : `${number} people`;
    } else {
      text = 'People';
    }

    return (
      <h2 className="ConversationSidebar-participants-title">
        {text}
      </h2>
    );
  }

  updateChatTitle = (title: string) => {
    ChatActions.updateChatTitle(this.props.chat, title);
  }

  renderParticipantNames() {
    const names = this.props.chat.getDisplayNames();
    return names.join(', ');
  }

  render() {
    const { chat } = this.props;

    return (
      <div className={cx('ConversationSidebar', this.props.className)} style={this.props.style}>
        {
          chat.isGroupType() &&
            <ChatForm
              chatName={chat.getTitle()}
              updateTitle={this.updateChatTitle}
            />
        }

        <ManageChatButton
          buttonClassName="ConversationSidebar-item-button"
          chat={chat}
        />

        <LeaveChatButton
          buttonClassName="ConversationSidebar-item-button"
          chat={chat}
        />

        <EmailChatHistoryButton
          buttonClassName="ConversationSidebar-item-button"
          chat={chat}
        />

        <div className="ConversationSidebar-participants">
          {this.renderParticipantsHeader()}
          <ConversationSidebarParticipants chat={chat} />
        </div>
      </div>
    );
  }
}

export default ConversationSidebar;



// WEBPACK FOOTER //
// ./src/chat/components/ConversationSidebar.jsx